export enum InfoModal {
  DISALLOWED_STATES,
  TRIP_COST_EXCEEDS_LIMIT,
}
